export const BLOCK_RECEIVED = 'BLOCK_RECEIVED';
export const ACCOUNTS_CHANGED = 'ACCOUNTS_CHANGED';
export const ACCOUNTS_RECOVERED = 'ACCOUNTS_RECOVERED';
export const ACCOUNTS_CHANGED_LOWER = 'ACCOUNTS_CHANGED_LOWER';
export const ACCOUNTS_RECOVERED_LOWER = 'ACCOUNTS_RECOVERED_LOWER';
export const LOGIN_TRIED = 'LOGIN_TRIED';
export const LOGIN_VALIDATE = 'LOGIN_VALIDATE';
export const LOGIN_JUDGE = 'LOGIN_JUDGE';
export const LOGIN_GRANTS = 'LOGIN_GRANTS';
export const LOGIN_GRANTED = 'LOGIN_GRANTED';
export const LOGIN_CHECK_USERNAME = 'LOGIN_CHECK_USERNAME';
export const SIGNUP_GRANTING = 'SIGNUP_GRANTING';
export const SIGNUP_GRANTED = 'SIGNUP_GRANTED';
export const SIGNUP_WILL_COMMIT = 'SIGNUP_WILL_COMMIT';
export const SIGNUP_CONFIRMING = 'SIGNUP_CONFIRMING';
export const SIGNUP_COMMITTING = 'SIGNUP_COMMITTING';
export const SIGNUP_COMMITTED = 'SIGNUP_COMMITTED';
export const SIGNUP_COMMIT_COMPLETE = 'SIGNUP_COMMIT_COMPLETE';
export const SIGNUP_CONFIGURATION_COMPLETE = 'SIGNUP_CONFIGURATION_COMPLETE';
